var EmailBuilderConstants = {

  INIT:              'init',
  INSERT: 'insert',
  INSERT_IMAGES: 'insertImages',
  INSERT_TEXT_VARIABLES: 'insertTextVariables',
  INSERT_TEXT_VARIABLES_INTO_INPUT: 'insertTextVariablesIntoInput',
  BLUR_INPUT: 'blurInput',
  FOCUS_INPUT: 'focusInput',
  CHANGE_EVENT: 'changeEvent',

  IMMEDIATELY: 'immediately',
  BEFORE: 'before',
  AFTER: 'after',
  MANUALLY: 'manually',

  WEEKLY: 'weekly',
  MONTHLY: 'monthly',

  SET_BODY: 'setBody',
  SET_CARET_POSITION: 'setCaretPosition',
  SET_EMAIL: 'setEmail',
  SET_REDACTOR: 'setRedactor',
  SET_VALUE: 'setValue',
  SET_ERRORS: 'setErrors',
  SET_ACTIVE_TAB: 'setActiveTab',
  SET_ROOM_TYPES: 'setRoomTypes',
  SET_PROPERTIES: 'setProperties',
};

export default EmailBuilderConstants
